export const destinations = [
  {
    id: 'b4c3e4e6-9053-42ce-b747-e281314baa31',
    description: 'Между двух морей.',
    name: 'Варениковская',
    pictures: [
      {
        src: 'https://lh3.googleusercontent.com/proxy/Yb2TtwZT2AvMkagwPIbBz0FdLmTCpYVZrzhLJpb3nEXwr76Bdvz4DCFLIHhRxWT8SZ7-mGutYHkFQL8MpOWnZd7XgW-C',
        description: 'Ляпота'
      },
      {
        src: 'https://s1.bloknot-krymska.ru/thumb/850x0xcut/upload/iblock/cb1/7iecdsrwqs9ulb0lbyxhvs0cn31gyi5s/photo_2023_05_03_10_57_22.jpg',
        description: 'Лов ю'
      },
      {
        src: 'https://avatars.mds.yandex.net/get-altay/14907426/2a00000198717dba7f6fcc1170fd82a4e449/M_height',
        description: 'Шаурма'
      }
    ]
  },
  {
    id: 'bfa5cb75-a1fe-4b77-a84c-0e528e910e04',
    description: 'Только сейчас вы можете довольствоваться свежей мазутой, на прекраном берегу курота Анапа и дольствоваться видами всплывающей брюхом рыбы.',
    name: 'Анапа',
    pictures: [
      {
        src: 'https://anapa.media/wp-content/uploads/2024/12/whatsapp-image-2024-12-17-at-08.55.45-1-1.jpg',
        description: 'Красота неописуемая'
      }
    ]
  },
  {
    id: 'bfa5cb75-a1fe-4b77-a83c-1e528e910e04',
    description: '',
    name: 'Геленджик',
    pictures: [],
  },
];
